module.exports = __webpack_public_path__ + "static/media/FTD-logo.c301681c.png";